// Auto-generated from countries.geojson - do not edit manually.
export const COUNTRY_CENTROIDS = {
  "AD": { name: "Andorra", lat: 42.54859834854764, lng: 1.5802243611232873 },
  "AE": { name: "United Arab Emirates", lat: 24.18250292309135, lng: 54.27920525789581 },
  "AF": { name: "Afghanistan", lat: 34.13402601376932, lng: 66.59216131095278 },
  "AG": { name: "Antigua and Barbuda", lat: 17.07146759372967, lng: -61.78530823226373 },
  "AI": { name: "Anguilla", lat: 18.222874004219086, lng: -63.06008343771806 },
  "AL": { name: "Albania", lat: 41.14165894891656, lng: 20.061082767269493 },
  "AM": { name: "Armenia", lat: 40.17841274230679, lng: 45.05490831965259 },
  "AO": { name: "Angola", lat: -12.167424062667942, lng: 17.651768783079 },
  "AQ": { name: "Antarctica", lat: -77.16987521415838, lng: -177.56451613408842 },
  "AR": { name: "Argentina", lat: -35.697270518120085, lng: -64.53238503843076 },
  "AS": { name: "American Samoa", lat: -14.305711987770538, lng: -170.7007316174498 },
  "AT": { name: "Austria", lat: 47.631858269895794, lng: 13.797778364631036 },
  "AU": { name: "Australia", lat: -25.697337673983082, lng: 134.02277170916162 },
  "AW": { name: "Aruba", lat: 12.515625722992898, lng: -69.97564014284046 },
  "AZ": { name: "Azerbaijan", lat: 40.3920509942049, lng: 48.634592670644324 },
  "BA": { name: "Bosnia and Herzegovina", lat: 44.14415356126429, lng: 17.83467240787538 },
  "BB": { name: "Barbados", lat: 13.183219369337529, lng: -59.557383949150285 },
  "BD": { name: "Bangladesh", lat: 23.673728665121, lng: 90.43212562608613 },
  "BE": { name: "Belgium", lat: 50.6182138854095, lng: 4.675010154696485 },
  "BF": { name: "Burkina Faso", lat: 12.108709036312737, lng: -1.6932816211842325 },
  "BG": { name: "Bulgaria", lat: 42.82043677302438, lng: 25.251739122561908 },
  "BH": { name: "Bahrain", lat: 26.04798501537066, lng: 50.540695402276775 },
  "BI": { name: "Burundi", lat: -3.261251993278643, lng: 29.88518227845293 },
  "BJ": { name: "Benin", lat: 9.503013199615893, lng: 2.305714528830206 },
  "BL": { name: "Saint Barthelemy", lat: 17.90561691241738, lng: -62.83051610005156 },
  "BM": { name: "Bermuda", lat: 32.315067430740726, lng: -64.7458500599169 },
  "BN": { name: "Brunei Darussalam", lat: 4.543205889917609, lng: 114.6430958360464 },
  "BO": { name: "Bolivia", lat: -16.7312488393574, lng: -64.45209597511206 },
  "BQ": { name: "Bonaire", lat: 12.180844982440338, lng: -68.29350445958761 },
  "BQ": { name: "Saba", lat: 17.632512616389718, lng: -63.23739481909494 },
  "BQ": { name: "Saint Eustatius", lat: 17.4919042294197, lng: -62.978230589445026 },
  "BR": { name: "Brazil", lat: -11.524630416426652, lng: -54.355206608256424 },
  "BS": { name: "Bahamas", lat: 24.72162633646784, lng: -78.07275370060313 },
  "BT": { name: "Bhutan", lat: 27.42163933959824, lng: 90.46716647173861 },
  "BV": { name: "Bouvet Island", lat: -54.42316679395248, lng: 3.411969465057627 },
  "BW": { name: "Botswana", lat: -22.236609002062902, lng: 23.85779956995608 },
  "BY": { name: "Belarus", lat: 53.46791374543163, lng: 27.964252054715104 },
  "BZ": { name: "Belize", lat: 17.24252476647155, lng: -88.68273510023441 },
  "CA": { name: "Canada", lat: 57.550480044655636, lng: -98.41680517868062 },
  "CC": { name: "Cocos Islands", lat: -12.171249450199545, lng: 96.83688767323002 },
  "CD": { name: "Congo DRC", lat: -3.338629596207896, lng: 23.419827574282188 },
  "CF": { name: "Central African Republic", lat: 6.331390033944319, lng: 20.520743419397256 },
  "CG": { name: "Congo", lat: -0.7294391595233845, lng: 14.879732849491393 },
  "CH": { name: "Switzerland", lat: 46.73678128684938, lng: 8.286928794895285 },
  "CI": { name: "Côte d'Ivoire", lat: 7.536779279421307, lng: -5.571710194917734 },
  "CK": { name: "Cook Islands", lat: -21.222613253399842, lng: -159.78768870952257 },
  "CL": { name: "Chile", lat: -37.82938283049967, lng: -70.76863431739216 },
  "CM": { name: "Cameroon", lat: 6.294168487480992, lng: 12.948474142398263 },
  "CN": { name: "China", lat: 38.07325481105728, lng: 104.69113855849604 },
  "CO": { name: "Colombia", lat: 4.187753877352739, lng: -72.6445066243485 },
  "CR": { name: "Costa Rica", lat: 9.863467407406214, lng: -84.14673625701816 },
  "CU": { name: "Cuba", lat: 21.476176522869448, lng: -79.69817857618705 },
  "CV": { name: "Cabo Verde", lat: 15.076411518651643, lng: -23.63401005900474 },
  "CW": { name: "Curacao", lat: 12.199996647939832, lng: -68.96939768599042 },
  "CX": { name: "Christmas Island", lat: -10.446440802183416, lng: 105.70209512200549 },
  "CY": { name: "Cyprus", lat: 35.11700416345239, lng: 33.375346009199205 },
  "CZ": { name: "Czech Republic", lat: 49.74917370930982, lng: 15.383273292023533 },
  "DE": { name: "Germany", lat: 51.08304539800482, lng: 10.426171427430804 },
  "DJ": { name: "Djibouti", lat: 11.750235727618804, lng: 42.613496898789506 },
  "DK": { name: "Denmark", lat: 56.00118817971057, lng: 9.378670542409406 },
  "DM": { name: "Dominica", lat: 15.429269860940513, lng: -61.360471946942994 },
  "DO": { name: "Dominican Republic", lat: 18.77954818522993, lng: -70.43495198520012 },
  "DZ": { name: "Algeria", lat: 28.350969744889056, lng: 2.6558464719769135 },
  "EC": { name: "Ecuador", lat: -1.5642721388853116, lng: -78.4630326109714 },
  "EE": { name: "Estonia", lat: 58.648108311231034, lng: 25.916870250633806 },
  "EG": { name: "Egypt", lat: 26.60517034450628, lng: 30.240135435012338 },
  "ER": { name: "Eritrea", lat: 15.005533147667684, lng: 39.2672401449901 },
  "ES": { name: "Spain", lat: 40.365008336683836, lng: -3.6516251409956983 },
  "ES": { name: "Canarias", lat: 28.297665106525546, lng: -16.53799441021647 },
  "ET": { name: "Ethiopia", lat: 8.729389557048396, lng: 39.914902886544276 },
  "FI": { name: "Finland", lat: 65.01578959749911, lng: 25.65738433454702 },
  "FJ": { name: "Fiji", lat: -17.822470952336204, lng: 177.98144613732626 },
  "FK": { name: "Falkland Islands", lat: -51.75901312766726, lng: -58.746646363799854 },
  "FM": { name: "Micronesia", lat: 6.8789448129255435, lng: 158.2291899444527 },
  "FO": { name: "Faroe Islands", lat: 62.130896281495346, lng: -6.9811060913122835 },
  "FR": { name: "France", lat: 46.6423682169416, lng: 2.1940236627886227 },
  "GA": { name: "Gabon", lat: -0.628448459921234, lng: 11.839410898545754 },
  "GB": { name: "United Kingdom", lat: 53.97844735080214, lng: -2.852943909329258 },
  "GD": { name: "Grenada", lat: 12.112926656338907, lng: -61.67937937204098 },
  "GE": { name: "Georgia", lat: 42.17986277737226, lng: 43.378866534112234 },
  "GF": { name: "French Guiana", lat: 3.857429742497078, lng: -53.32232307156624 },
  "GG": { name: "Guernsey", lat: 49.45870771378872, lng: -2.576392582891568 },
  "GH": { name: "Ghana", lat: 7.94530467243628, lng: -1.219233362526581 },
  "GI": { name: "Gibraltar", lat: 36.14022671336082, lng: -5.345549484594358 },
  "GL": { name: "Greenland", lat: 74.16847218965994, lng: -42.07567788066985 },
  "GM": { name: "Gambia", lat: 13.428617959189328, lng: -15.383380385869662 },
  "GN": { name: "Guinea", lat: 10.255986541378112, lng: -10.986948848040218 },
  "GP": { name: "Guadeloupe", lat: 16.24420002705553, lng: -61.54382262282755 },
  "GQ": { name: "Equatorial Guinea", lat: 1.5954643936590733, lng: 10.425456672353823 },
  "GR": { name: "Greece", lat: 39.42012261727978, lng: 23.110368936161876 },
  "GS": { name: "South Georgia and South Sandwich Islands", lat: -54.37666443862139, lng: -36.77509575898928 },
  "GT": { name: "Guatemala", lat: 15.820878515352684, lng: -90.31219349119617 },
  "GU": { name: "Guam", lat: 13.445430479945276, lng: 144.78024458298802 },
  "GW": { name: "Guinea-Bissau", lat: 11.980075324820504, lng: -14.980186756910847 },
  "GY": { name: "Guyana", lat: 4.68211981385056, lng: -58.91352612754667 },
  "HM": { name: "Heard Island and McDonald Islands", lat: -53.084170035513736, lng: 73.49298560844045 },
  "HN": { name: "Honduras", lat: 14.740370695750006, lng: -86.49251679006962 },
  "HR": { name: "Croatia", lat: 44.91192100856702, lng: 16.625761129583374 },
  "HT": { name: "Haiti", lat: 18.883520486983567, lng: -72.89291379842 },
  "HU": { name: "Hungary", lat: 47.22527332486294, lng: 19.39620048366142 },
  "ID": { name: "Indonesia", lat: 0.15591979959037652, lng: 113.96538246847302 },
  "IE": { name: "Ireland", lat: 53.30489539816495, lng: -8.241128545554096 },
  "IL": { name: "Israel", lat: 31.513542220043195, lng: 35.027923472437024 },
  "IM": { name: "Isle of Man", lat: 54.22855301008011, lng: -4.532995055468449 },
  "IN": { name: "India", lat: 23.586300567746722, lng: 81.17300408530181 },
  "IO": { name: "British Indian Ocean Territory", lat: -7.323548444385743, lng: 72.43501618476016 },
  "IQ": { name: "Iraq", lat: 33.105075667527906, lng: 43.832529181056884 },
  "IR": { name: "Iran", lat: 32.906023742890056, lng: 54.237077001065444 },
  "IS": { name: "Iceland", lat: 65.12360920205514, lng: -19.05682967106099 },
  "IT": { name: "Italy", lat: 42.98201127614267, lng: 12.763657166123137 },
  "JE": { name: "Jersey", lat: 49.215396925724306, lng: -2.1291601162653575 },
  "JM": { name: "Jamaica", lat: 18.12207889341651, lng: -77.30358894542778 },
  "JO": { name: "Jordan", lat: 31.387064884449156, lng: 36.95728884547246 },
  "JP": { name: "Japan", lat: 36.76738832597829, lng: 137.46934234351835 },
  "KE": { name: "Kenya", lat: 0.6899182318376179, lng: 37.95309411262371 },
  "KG": { name: "Kyrgyzstan", lat: 41.35698905438358, lng: 74.17532903468319 },
  "KH": { name: "Cambodia", lat: 12.699186865507775, lng: 105.03973078680701 },
  "KI": { name: "Kiribati", lat: 1.8676673749241066, lng: -157.39024189323504 },
  "KM": { name: "Comoros", lat: -11.658861474508491, lng: 43.34826587429403 },
  "KN": { name: "Saint Kitts and Nevis", lat: 17.314736299587768, lng: -62.74560385895787 },
  "KP": { name: "North Korea", lat: 40.19198091470839, lng: 127.3379805653744 },
  "KR": { name: "South Korea", lat: 36.402386712544114, lng: 127.76224551357649 },
  "KW": { name: "Kuwait", lat: 29.281360965443092, lng: 47.56311109320184 },
  "KY": { name: "Cayman Islands", lat: 19.311231805620288, lng: -81.25203208977878 },
  "KZ": { name: "Kazakhstan", lat: 47.641465195176835, lng: 66.3759193479301 },
  "LA": { name: "Laos", lat: 18.117282736873282, lng: 103.76375899026448 },
  "LB": { name: "Lebanon", lat: 33.91160170722086, lng: 35.89651946324749 },
  "LC": { name: "Saint Lucia", lat: 13.895749185129906, lng: -60.9689510935251 },
  "LI": { name: "Liechtenstein", lat: 47.14627562133036, lng: 9.547674672376376 },
  "LK": { name: "Sri Lanka", lat: 7.696630939329944, lng: 80.66931169770622 },
  "LR": { name: "Liberia", lat: 6.52012979398834, lng: -9.258988935497618 },
  "LS": { name: "Lesotho", lat: -29.60168116924817, lng: 28.24475317864227 },
  "LT": { name: "Lithuania", lat: 55.29437393417175, lng: 23.946021605013534 },
  "LU": { name: "Luxembourg", lat: 49.77523454542369, lng: 6.103230338458876 },
  "LV": { name: "Latvia", lat: 56.813853047554154, lng: 24.693671325654403 },
  "LY": { name: "Libya", lat: 27.202915771690794, lng: 17.91133392454237 },
  "MA": { name: "Morocco", lat: 28.687598134979325, lng: -8.817212587250811 },
  "MC": { name: "Monaco", lat: 43.74798224995656, lng: 7.412820873271196 },
  "MD": { name: "Moldova", lat: 47.0725674580696, lng: 28.391111865941348 },
  "ME": { name: "Montenegro", lat: 42.73694835210454, lng: 19.29505087156758 },
  "MF": { name: "Saint Martin", lat: 18.078012113224464, lng: -63.06678525361946 },
  "MG": { name: "Madagascar", lat: -19.04163612493041, lng: 46.68493466832544 },
  "MH": { name: "Marshall Islands", lat: 7.307929900994344, lng: 168.72016025351076 },
  "MK": { name: "North Macedonia", lat: 41.59402890143112, lng: 21.70998923872772 },
  "ML": { name: "Mali", lat: 17.168146208584837, lng: -4.346399841781153 },
  "MM": { name: "Myanmar", lat: 19.901227931399873, lng: 97.08892285397344 },
  "MN": { name: "Mongolia", lat: 47.08644454604851, lng: 103.3987360327455 },
  "MP": { name: "Northern Mariana Islands", lat: 15.178063516432115, lng: 145.74119737203134 },
  "MQ": { name: "Martinique", lat: 14.642697353597645, lng: -61.01432380875083 },
  "MR": { name: "Mauritania", lat: 20.466731212820022, lng: -10.495079045035716 },
  "MS": { name: "Montserrat", lat: 16.735363391460357, lng: -62.18693281256255 },
  "MT": { name: "Malta", lat: 35.890522650899314, lng: 14.441922442508494 },
  "MU": { name: "Mauritius", lat: -20.28142317475198, lng: 57.56415671066546 },
  "MV": { name: "Maldives", lat: -0.6065577168009924, lng: 73.10076245140479 },
  "MW": { name: "Malawi", lat: -13.128986464184024, lng: 34.23441182298881 },
  "MX": { name: "Mexico", lat: 23.87436068093592, lng: -101.55399731630118 },
  "MY": { name: "Malaysia", lat: 3.6716608556387857, lng: 114.63330303992869 },
  "MZ": { name: "Mozambique", lat: -17.525230309488748, lng: 35.208577031290176 },
  "NA": { name: "Namibia", lat: -21.90858163281473, lng: 18.16451345845268 },
  "NC": { name: "New Caledonia", lat: -21.33003372660827, lng: 165.50767040438612 },
  "NE": { name: "Niger", lat: 17.08105392407292, lng: 8.86863247002646 },
  "NF": { name: "Norfolk Island", lat: -29.037654445046282, lng: 167.95259597483337 },
  "NG": { name: "Nigeria", lat: 9.61029352034213, lng: 8.147714845256194 },
  "NI": { name: "Nicaragua", lat: 12.893566631930554, lng: -85.016088327669 },
  "NL": { name: "Netherlands", lat: 52.134054128923886, lng: 5.554136426128487 },
  "NO": { name: "Norway", lat: 64.97775882947745, lng: 16.670259272390894 },
  "NP": { name: "Nepal", lat: 28.300920699755657, lng: 84.1338898313567 },
  "NR": { name: "Nauru", lat: -0.5221021440668993, lng: 166.92937633139178 },
  "NU": { name: "Niue", lat: -19.05230921680393, lng: -169.86878106699083 },
  "NZ": { name: "New Zealand", lat: -43.82765432544426, lng: 170.69035541428696 },
  "OM": { name: "Oman", lat: 20.7242833183209, lng: 55.841088119829 },
  "PA": { name: "Panama", lat: 8.439536749576892, lng: -80.14428761482796 },
  "PE": { name: "Peru", lat: -8.522717984240291, lng: -74.11416196781884 },
  "PF": { name: "French Polynesia", lat: -17.674684080120677, lng: -149.40041671099763 },
  "PG": { name: "Papua New Guinea", lat: -7.156912819152135, lng: 144.8348942994695 },
  "PH": { name: "Philippines", lat: 15.586542251094242, lng: 121.82208941416745 },
  "PK": { name: "Pakistan", lat: 30.116188371410882, lng: 69.08835090769651 },
  "PL": { name: "Poland", lat: 52.06848055692473, lng: 19.43573279234468 },
  "PM": { name: "Saint Pierre and Miquelon", lat: 46.95153913615198, lng: -56.32465353437558 },
  "PN": { name: "Pitcairn", lat: -24.366121747565458, lng: -128.3149848627581 },
  "PR": { name: "Puerto Rico", lat: 18.216224086610914, lng: -66.49425339593509 },
  "PS": { name: "Palestinian Territory", lat: 31.930818736453883, lng: 35.24251184154588 },
  "PT": { name: "Portugal", lat: 39.67529214702138, lng: -7.933662183874006 },
  "PW": { name: "Palau", lat: 7.534775852547396, lng: 134.57965086721052 },
  "PY": { name: "Paraguay", lat: -23.42190559259428, lng: -58.38906357428651 },
  "QA": { name: "Qatar", lat: 25.318528486425386, lng: 51.19794918743203 },
  "RE": { name: "Réunion", lat: -21.119825460665105, lng: 55.54393506194689 },
  "RO": { name: "Romania", lat: 45.82454894397586, lng: 25.094158201563292 },
  "RS": { name: "Serbia", lat: 44.02679870131969, lng: 20.85677444395745 },
  "RU": { name: "Russian Federation", lat: 59.039434214106194, lng: 98.6704990698032 },
  "RW": { name: "Rwanda", lat: -2.014687460047154, lng: 29.919439681764082 },
  "SA": { name: "Saudi Arabia", lat: 24.136038144757897, lng: 44.600958178225596 },
  "SB": { name: "Solomon Islands", lat: -9.613104734596515, lng: 160.16475795033884 },
  "SC": { name: "Seychelles", lat: -4.660002318822744, lng: 55.47250789595527 },
  "SD": { name: "Sudan", lat: 15.67060230984256, lng: 29.951458283594064 },
  "SE": { name: "Sweden", lat: 62.73420986108448, lng: 17.062431988004956 },
  "SG": { name: "Singapore", lat: 1.3528251890006349, lng: 103.81025757634053 },
  "SH": { name: "Saint Helena", lat: -15.962963318340398, lng: -5.717391620813109 },
  "SI": { name: "Slovenia", lat: 46.13759229564504, lng: 14.890636899973781 },
  "SJ": { name: "Svalbard", lat: 78.57318936469626, lng: 16.036378851505283 },
  "SK": { name: "Slovakia", lat: 48.69808390520484, lng: 19.581015362490966 },
  "SL": { name: "Sierra Leone", lat: 8.561330384750587, lng: -11.78656695731115 },
  "SM": { name: "San Marino", lat: 43.942820729097896, lng: 12.461278349581722 },
  "SN": { name: "Senegal", lat: 14.228861491763402, lng: -14.610875368352305 },
  "SO": { name: "Somalia", lat: 6.524534573103924, lng: 45.40037867243972 },
  "SR": { name: "Suriname", lat: 4.098723595920171, lng: -55.855514311561286 },
  "SS": { name: "South Sudan", lat: 7.657782041763295, lng: 30.3851856901788 },
  "ST": { name: "Sao Tome and Principe", lat: 0.22744704294793774, lng: 6.606158796857607 },
  "SV": { name: "El Salvador", lat: 13.758041517055418, lng: -88.85911489238985 },
  "SX": { name: "Sint Maarten", lat: 18.03942608463078, lng: -63.06883135915303 },
  "SY": { name: "Syria", lat: 35.09751106058316, lng: 38.5117323139514 },
  "SZ": { name: "Eswatini", lat: -26.562540935608702, lng: 31.510685746082007 },
  "TC": { name: "Turks and Caicos Islands", lat: 21.799865427483745, lng: -71.74058946811508 },
  "TD": { name: "Chad", lat: 15.283493546654503, lng: 18.427113900363025 },
  "TF": { name: "Juan De Nova Island", lat: -17.06449193630804, lng: 42.74374761089645 },
  "TF": { name: "French Southern Territories", lat: -49.26329687105643, lng: 69.54686984724839 },
  "TF": { name: "Glorioso Islands", lat: -11.566224871643417, lng: 47.290948081543384 },
  "TG": { name: "Togo", lat: 8.660743037717811, lng: 0.8990857571109684 },
  "TH": { name: "Thailand", lat: 13.66222784745538, lng: 101.08675116214552 },
  "TJ": { name: "Tajikistan", lat: 38.56933138382972, lng: 70.94215281065698 },
  "TK": { name: "Tokelau", lat: -9.195174767256544, lng: -171.85265950722743 },
  "TL": { name: "Timor-Leste", lat: -8.809894630601962, lng: 125.95024049562659 },
  "TM": { name: "Turkmenistan", lat: 39.06069118001429, lng: 58.4577357627054 },
  "TN": { name: "Tunisia", lat: 34.08636179565723, lng: 9.65587551697984 },
  "TO": { name: "Tonga", lat: -21.15927212823853, lng: -175.20415878511247 },
  "TR": { name: "Turkey", lat: 38.93207363123396, lng: 35.56886764076691 },
  "TT": { name: "Trinidad and Tobago", lat: 10.415515638298093, lng: -61.37236579976247 },
  "TV": { name: "Tuvalu", lat: -8.514701506447222, lng: 179.217833977593 },
  "TZ": { name: "Tanzania", lat: -6.355794440041147, lng: 34.81832206060381 },
  "UA": { name: "Ukraine", lat: 48.657532515563794, lng: 31.27377208442636 },
  "UG": { name: "Uganda", lat: 1.2821729218416205, lng: 32.34371768463123 },
  "UM": { name: "United States Minor Outlying Islands", lat: 19.302045812215958, lng: 166.63800339749642 },
  "US": { name: "United States", lat: 38.8208089190304, lng: -96.33161660829639 },
  "UY": { name: "Uruguay", lat: -32.78195043831093, lng: -56.01919523458085 },
  "UZ": { name: "Uzbekistan", lat: 41.4879065244633, lng: 63.8548297593985 },
  "VA": { name: "Vatican City", lat: 41.90402351316735, lng: 12.451312917026133 },
  "VC": { name: "Saint Vincent and the Grenadines", lat: 13.254808122970651, lng: -61.193766354393034 },
  "VE": { name: "Venezuela", lat: 7.148324760507107, lng: -66.36492135985132 },
  "VG": { name: "British Virgin Islands", lat: 18.42195819619707, lng: -64.62406519257699 },
  "VI": { name: "US Virgin Islands", lat: 17.738009708772523, lng: -64.76155341409797 },
  "VN": { name: "Vietnam", lat: 16.517347170839393, lng: 105.91338832758704 },
  "VU": { name: "Vanuatu", lat: -15.189132121699332, lng: 166.84912735669738 },
  "WF": { name: "Wallis and Futuna", lat: -14.283442307826677, lng: -178.12735555777184 },
  "WS": { name: "Samoa", lat: -13.634252953274622, lng: -172.44107655740137 },
  "YE": { name: "Yemen", lat: 16.001392616307445, lng: 47.46815793206386 },
  "YT": { name: "Mayotte", lat: -12.824468416301052, lng: 45.128142327031064 },
  "ZA": { name: "South Africa", lat: -28.55361930679731, lng: 24.75252746489084 },
  "ZM": { name: "Zambia", lat: -13.162832953186246, lng: 27.75521363430896 },
  "ZW": { name: "Zimbabwe", lat: -18.92700121981475, lng: 29.717829640720844 },
};

export function getCountryCentroid(code) {
  if (!code) return null;
  return COUNTRY_CENTROIDS[code.toUpperCase()] || null;
}

export function getCountryCentroids() {
  return COUNTRY_CENTROIDS;
}